module.exports = __webpack_public_path__ + "img/Documentation.6a1a633b.svg";